import { Bar, Pie } from 'react-chartjs-2'

const BarChart = ({ options, data }) => {
  return <Bar options={options} data={data} />
}


export default BarChart;